import React, {Component} from "react"
import {Container, Divider, Header, Loader, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, parseMultilineString} from "../utils/localization";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getStepProps, isAnsel} from "../utils/common";
import Steps from "./steps/steps";
import Footer from "./footer";
import {CustomDivider, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        initialData, user, benAdmin,
        name: user.firstName,
        lang: user.lang,
        ...ownProps
    }
};

class Claims extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    render() {
        const {stepProps} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.claims;

        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                    <CustomGrid container stackable centered textAlign={'left'} className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid stackable columns={1}>
                                <CustomGrid.Column>
                                    <Header as='h2'>{strings.title}</Header>
                                    <p className={"neutral700Text"}>{parseMultilineString(strings.description)}</p>
                                </CustomGrid.Column>
                                <CustomGrid.Row columns={4}>
                                    <CustomGrid.Column textAlign={"center"}>
                                        <div style={{width: '150px', textAlign: "center"}}>
                                            <S3Image {...IMAGE.GET_MEDICAL_ATTENTION}/>
                                            <CustomDivider hidden small/>
                                            <CustomDivider hidden small/>
                                            <p className={"smaller"} style={{fontSize: '14px'}}>
                                                <b>{parseMultilineString(strings.receiveMedicalAttention)}</b></p>
                                        </div>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column textAlign={"center"}>
                                        <div style={{width: '150px', textAlign: "center"}}>
                                            <S3Image {...IMAGE.WHAT_HAPPENED}/>
                                            <CustomDivider hidden small/>
                                            <CustomDivider hidden small/>
                                            <p className={"smaller "} style={{fontSize: '14px'}}>
                                                <b>{parseMultilineString(strings.tellUsWhat)}</b></p>
                                        </div>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column textAlign={"center"}>
                                        <div style={{width: '170px', textAlign: "center"}}>
                                            <S3Image {...IMAGE.UPLOAD_DOCS}/>
                                            <CustomDivider hidden small/>
                                            <CustomDivider hidden small/>
                                            <p className={"smaller "} style={{fontSize: '14px'}}>
                                                <b>{parseMultilineString(strings.uploadPhotos)}</b></p>
                                        </div>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column textAlign={"center"}>
                                        <div style={{width: '170px', textAlign: "center"}}>
                                            <S3Image {...IMAGE.SELECT_PAYOUT_PREFERENCE}/>
                                            <CustomDivider hidden small/>
                                            <CustomDivider hidden small/>
                                            <p className={"smaller "} style={{fontSize: '14px'}}>
                                                <b>{parseMultilineString(strings.setPaymentPreference)}</b></p>
                                        </div>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                            <Divider hidden/>
                            <Segment basic>
                            <CustomGrid columns={2} verticalAlign={"middle"} style={{height: '200px'}} relaxed>
                                <CustomGrid.Column textAlign={"center"}>
                                    <p>
                                        {strings.ifYourClaimIsApproved}
                                    </p>
                                </CustomGrid.Column>
                                <CustomGrid.Column textAlign={"center"} style={{paddingRight: 0}}>
                                    <p>
                                        {strings.otherwiseOurFriendly}
                                    </p>
                                </CustomGrid.Column>
                            </CustomGrid>
                                <Divider vertical style={{zIndex: 0}}><span style={{fontSize: '12px'}}>{localization.or}</span></Divider>
                            </Segment>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Claims));
